import { render, staticRenderFns } from "./RulesPage.vue?vue&type=template&id=3c912ba0"
import script from "./RulesPage.vue?vue&type=script&lang=js"
export * from "./RulesPage.vue?vue&type=script&lang=js"
import style0 from "./RulesPage.vue?vue&type=style&index=0&id=3c912ba0&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports